export default __webpack_public_path__ + "static/media/hht2_Intonation_01.cafb677e.png";